export const FLOW_ROUTES = {
  students: [
    '/view-student',
    '/student-profile',
    '/transfer-student',
    '/generate-tc',
  ],
  collect: [
    '/collect',
    '/collect-fee-details',
  ],
  feeCollectionReport: [
    '/fee-collection-report',
    '/fee-collection-report-details',
  ],
  feeDueReport: [
    '/fee-due-report',
    '/fee-due-report-details',
  ],
  feeReport: [
    '/fees-report',
    '/class-wise-fee-report',
    '/student-profile',
  ],
  classWiseFeeReport: [
    '/class-wise-fee-report',
    '/student-profile',
  ],
  transferReport: [
    '/tc-report',
    '/generate-tc'
  ],
  staffManagement: [
    '/staff-manage',
    '/staff-profile',
  ],
};